import SemanticPageDocument from '@/components/semantic/SemanticPageDocument';
import { getSemanticPageByPath } from '@/lib/semantic-content/pages';
import NotFound from '@/pages/NotFound';

export default function MapleOSForConsumers() {
  const page = getSemanticPageByPath('/mapleos-for-consumers');

  return page ? <SemanticPageDocument page={page} /> : <NotFound />;
}
